import { useTranslation } from 'react-i18next';

import { Field, FieldDescription, FieldLabel } from '@/components/ui/field';
import { Skeleton } from '@/components/ui/skeleton';

import { BuildInfo } from '@/entities/layout';

interface ServerInfoFieldProps {
  isLoading: boolean;
  buildInfo?: BuildInfo;
}

export const ServerInfoField = ({ isLoading, buildInfo }: ServerInfoFieldProps) => {
  const { t } = useTranslation();

  return (
    <Field>
      <FieldLabel>{t('about.serverInfo', 'Current Server Version / Database Schema')}</FieldLabel>
      {isLoading ? (
        <Skeleton className="h-5 w-40" />
      ) : (
        <FieldDescription>
          {buildInfo?.version} / {buildInfo?.databaseVersion}
        </FieldDescription>
      )}
    </Field>
  );
};
